import * as React from 'react';
import { Layout, Row, Col, Card, Button, message } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { siteSurveysRestCrudThunksForSupplier } from '../../thunks/site_surveys_thunks';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import { EmptyState } from '../empty_state/EmptyState';
import { WalkthroughRowDisplay } from '../walkthrough_row_display/WalkthroughRowDisplay';
import { walkthroughsRestCrudThunksForSupplier } from '../../thunks/walkthroughs_thunks';
import { TaskList } from '../task_list/TaskList';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import SupplierScheduleWalkthroughModalForm from '../supplier_schedule_walkthrough_modal_form/SupplierScheduleWalkthroughModalForm';
import SupplierLocationCardDisplay from '../supplier_location_card_display/SupplierLocationCardDisplay';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const { Content } = Layout;

require('./SupplierSiteSurveysDetailDetailsPage.less');
const SITE_SURVEY_ASSOCIATED_WORKTHROUGHS = 'siteSurveyAssociatedWalkthroughs';

class SiteSurveysDetailPage extends React.Component<any, any> {
	formRefs: any = {
		scheduleWalkthroughForm: null,
	};

	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			scheduleWalkthroughFormVisible: false,
		};
	}

	componentDidMount() {
		const {
			getSiteSurvey,

			match,
		} = this.props;
		const siteSurveyId = match.params.id;
		getSiteSurvey(siteSurveyId).then(() => {
			this.setState({ loading: false });
		});
	}

	handleSchedule = (e) => {
		this.setState({
			scheduleWalkthroughFormVisible: true,
		});
		e.stopPropagation();
		e.preventDefault();
	};

	refreshSiteSurvey = () => {
		const {
			getSiteSurvey,

			match,
		} = this.props;
		this.setState({ loading: true });
		const siteSurveyId = match.params.id;
		getSiteSurvey(siteSurveyId).then(() => {
			this.setState({ loading: false });
		});
	};

	handleScheduleWalkthroughSubmit = () => {
		const { createWalkthrough, getSiteSurvey, match, currentUser } = this.props;
		const form = this.formRefs['scheduleWalkthroughForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const siteSurveyId = match.params.id;
			getSiteSurvey(siteSurveyId).then((survey) => {
				const updateValues = {
					...values,
					title: survey.title + ' walkthrough',
					status: 'incomplete',
					locationId: survey.locationId,
					siteSurveyId: survey.id,
					scheduledBy: currentUser.email,
					buyerCompanyId: nullSafeGet(
						'facility.supplierCompany.privateBuyerCompanyId',
						currentUser
					),
				};

				createWalkthrough(updateValues).then(() => {
					this.setState({ scheduleWalkthroughFormVisible: false });
					this.refreshSiteSurvey();
					message.success(`Walkthrough scheduled.`);
				});
			});
		});
	};

	handleScheduleWalkthroughCancel = (e) => {
		this.setState({
			scheduleWalkthroughFormVisible: false,
		});
	};

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	render() {
		const { match, siteSurvey, history } = this.props;

		const { loading } = this.state;

		const siteSurveyId = match.params.id;

		const walkthroughsColumns = [
			{
				title: 'Name',
				dataIndex: 'title',
				render: (text, record) => <WalkthroughRowDisplay walkthrough={record} />,
			},
		];
		const onWalkthroughsRow = (record) => ({
			onClick: () => history.push(`/supplier/siteSurveys/walkthrough/detail/${record.id}`),
		});

		return loading ? (
			<PageLoadingPlaceholder />
		) : (
			<Content className="siteSurveysDetailDetailsPage">
				<LogOnMountWithStandardEventProperties eventType="visited supplier site survey detail page" />
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<SupplierScheduleWalkthroughModalForm
					formData={{}}
					wrappedComponentRef={this.saveFormRef('scheduleWalkthroughForm')}
					visible={this.state.scheduleWalkthroughFormVisible}
					onCancel={this.handleScheduleWalkthroughCancel}
					onSubmit={this.handleScheduleWalkthroughSubmit}
				/>
				<Row style={{ margin: '16px 4px' }} gutter={12}>
					<Col span={16}>
						<div className="rowSpacing">
							<Card
								title="Walkthroughs"
								extra={
									<AccessPermissionChecker name={PERMISSION_NAMES.ADD_WALKTHROUGHS}>
										<Button
											style={{
												position: 'absolute',
												right: 32,
												top: 12.5,
											}}
											type="primary"
											onClick={this.handleSchedule}
										>
											Schedule Walkthrough
										</Button>
									</AccessPermissionChecker>
								}
							>
								<PaginatedReduxTable
									showHeader={false}
									emptyState={
										<EmptyState
											graphic={
												<img
													style={{ marginBottom: 8 }}
													src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
													alt={"You haven't conducted any walkthroughs yet."}
												/>
											}
											headline={"You haven't conducted any walkthroughs yet."}
											body={
												<div style={{ textAlign: 'center' }}>
													<div style={{ maxWidth: 440, marginBottom: 16 }}></div>
												</div>
											}
										/>
									}
									collectionName="walkthroughs"
									targetCollectionName={SITE_SURVEY_ASSOCIATED_WORKTHROUGHS}
									columns={walkthroughsColumns}
									onRow={onWalkthroughsRow}
									keyAccessor={(el) => el.id}
									initialFilters={{ siteSurveyId: siteSurveyId }}
									initialPagination={{ current: 1, pageSize: 10 }}
									fetchData={walkthroughsRestCrudThunksForSupplier.read}
								/>
							</Card>
						</div>
						<div className="rowSpacing">
							<Card title="Tasks">
								<TaskList tasks={nullSafeGetOrElse('tasks', siteSurvey, [])} />
							</Card>
						</div>
					</Col>
					<Col span={8}>
						{nullSafeGet('location', siteSurvey) ? (
							<div className="rowSpacing">
								<SupplierLocationCardDisplay
									location={siteSurvey.location}
									onViewLocationPage={() =>
										history.push(
											`/supplier/locations/detail/${nullSafeGet('location.id', siteSurvey)}`
										)
									}
								/>
							</div>
						) : null}
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	siteSurveysFetching: state.site_surveys.fetching,
	siteSurvey: state.site_surveys.detail,
	walkthroughs: state.walkthroughs,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({
	getSiteSurvey: (id) => dispatch(siteSurveysRestCrudThunksForSupplier.readOne(id)),
	createWalkthrough: (entity) => dispatch(walkthroughsRestCrudThunksForSupplier.create(entity)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiteSurveysDetailPage));
